import * as actionTypes from 'store/actionTypes';

const INITIAL_STATE = {
  isLoading: true,
  list: [],
  registrationLocations: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_COUNTRY_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.GET_COUNTRY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload.countries,
      };
    case actionTypes.GET_COUNTRY_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    case actionTypes.GET_REGISTRATION_LOCATION_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.GET_REGISTRATION_LOCATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        registrationLocations: action.payload.locations,
      };
    case actionTypes.GET_REGISTRATION_LOCATION_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};
